<template>

  <footer class="c-footer" :class="footerClass">
    <div class="c-footer__container">

        <template v-if="typeof footer !== 'undefined' && footer.length" v-for="item in footer">
            <a v-if="item.linkType=='external'" :href="item.url" :target="item.target">{{item.text}}</a>
            <router-link v-if="item.linkType=='internal'" :target="item.target" :to="{name: 'Page_' + item.id}">{{item.text}}</router-link>
        </template>

    </div>
  </footer>

</template>


<script>
import { mapGetters } from 'vuex'

export default {
  mounted () {
    this.footer = this.websiteConfig.nav_footer
  },
  data () {
    return {
      footer: ''
    }
  },
  computed: {
    ...mapGetters([
      'websiteConfig'
    ]),
    footerClass () {
      return {
        'c-footer--login-page': this.$route.name === 'Login'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppFooter.vue?f40011da